/**
 * Token Logo Utilities
 * Maps token symbols to their static logo assets
 */

// Supported tokens with local logo assets
const SUPPORTED_TOKENS = [
  'BTC', 'ETH', 'USDT', 'USDC', 'SOL', 'MATIC', 'POL',
  'BNB', 'AVAX', 'DAI', 'BUSD', 'XRP', 'ADA', 'XLM',
  'CUSD', 'XAUT', 'PYUSD'
] as const;

/**
 * Get token logo URL from static assets
 * @param tokenSymbol - Token symbol (e.g., "BTC", "ETH")
 * @returns Local asset path or null if not found
 */
export function getTokenLogoUrl(tokenSymbol: string): string | null {
  const symbol = tokenSymbol.toUpperCase();

  // Check if we have a local asset for this token
  if (SUPPORTED_TOKENS.includes(symbol as any)) {
    return `/assets/tokens/${symbol.toLowerCase()}.png`;
  }

  return null;
}

/**
 * Get fallback color for token (used when logo fails to load)
 */
export function getTokenColor(symbol: string): string {
  const colors: Record<string, string> = {
    USDT: '#26A17B',
    USDC: '#2775CA',
    BTC: '#F7931A',
    ETH: '#627EEA',
    SOL: '#14F195',
    MATIC: '#8247E5',
    POL: '#8247E5',
    BNB: '#F3BA2F',
    AVAX: '#E84142',
    DAI: '#F5AC37',
    BUSD: '#F0B90B',
    XRP: '#00AAE4',
    ADA: '#0033AD',
    DOT: '#E6007A',
    LINK: '#2A5ADA',
    UNI: '#FF007A',
    XLM: '#000000',
    CUSD: '#35D07F',
    XAUT: '#D4AF37',
    PYUSD: '#0070BA',
  };
  return colors[symbol.toUpperCase()] || '#64748B';
}

/**
 * Preload token logo image
 */
export function preloadTokenLogo(url: string): Promise<void> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve();
    img.onerror = reject;
    img.src = url;
  });
}
